module.exports = __webpack_public_path__ + "media/landing-page/hive-left-5c117769.png";